import { _ } from '../utils.js'
import Vimeo from '@vimeo/player'
import loading from '../templates/loading.js'

export default (self) => {
    const element = self.el
    const loadingContainer = _('loading-container', 'element').nodeFrom(element)
    const videoId = self.video.dataset.videoId
    const videoHashId = self.video.dataset.videoHashId
    const scrollTrigger = element.dataset?.scrollTrigger
    let player
    let loaded = false
    let scrolledTo = false
    let vimeoPlayerReady = () => {}
    let vimeoPlayVideo = () => {}
    let vimeoPauseVideo = () => {}

    const loadVimeoAndPlay = () => {
        loadingContainer.innerHTML = loading('loading--whiteout')

        const params = new URLSearchParams({
            h: videoHashId ?? '',
            muted: scrollTrigger ?? '',
        })

        player = new Vimeo(self.video, {
            height: 599,
            url: `https://player.vimeo.com/video/${videoId}?${params.toString()}`,
            responsive: true,
            width: self.video.offsetWidth,
            muted: scrollTrigger === 'true',
        })

        player.on('loaded', () => {
            loadingContainer.innerHTML = ''
            loaded = true
        })

        vimeoPlayerReady()
    }

    vimeoPlayerReady = () => {
        if (loaded === false) {
            vimeoPlayVideo()
        }
        self.controls.play.removeEventListener('click', loadVimeoAndPlay)
        self.controls.play.addEventListener('click', vimeoPlayVideo)
        self.controls.pause.addEventListener('click', vimeoPauseVideo)
    }

    vimeoPlayVideo = () => {
        player.play()
        element.classList.add(self.activeClass)
    }

    vimeoPauseVideo = () => {
        player.pause()
        element.classList.remove(self.activeClass)
    }

    const handleScrollTrigger = () => {
        const offsetTop =
            element.getBoundingClientRect().top - window.innerHeight

        if (!scrolledTo && offsetTop < 0) {
            self.controls.play.dispatchEvent(new Event('click'))
            scrolledTo = true
        }
    }

    self.controls.play.addEventListener('click', loadVimeoAndPlay)

    if (scrollTrigger) {
        handleScrollTrigger()
        window.addEventListener('scroll', () => {
            handleScrollTrigger()
        })
    }

    return {
        loadVimeoAndPlay,
        vimeoPlayerReady,
        vimeoPlayVideo,
        vimeoPauseVideo,
    }
}
